/**
 * Derives display labels for "Found in the document" chips from naming
 * preview_values. Uses canonical variable keys only (no hint suffixes like
 * "year:YY"), with one exception: the `month` field is surfaced as the
 * written-out month ("June") rather than its bare number ("6").
 */
export const getFoundInDocumentLabels = (
  previewValues?: Record<string, string> | null,
): string[] => {
  if (!previewValues) return [];

  const seen = new Set<string>();
  const labels: string[] = [];

  Object.entries(previewValues).forEach(([key, value]) => {
    if (key.includes(':')) return;
    let trimmed = value?.trim();

    // `month` comes back as a bare number (e.g. "6"), which reads as a
    // confusing, contextless chip next to the spelled-out month. Prefer the
    // written-out month ("June") from the hint variants; if none is available,
    // skip rather than surface a stray number.
    if (key === 'month' && trimmed && /^\d+$/.test(trimmed)) {
      const monthWord =
        previewValues['month:Month']?.trim() ||
        previewValues['month:Mon']?.trim();
      if (!monthWord) return;
      trimmed = monthWord;
    }

    if (!trimmed || seen.has(trimmed)) return;
    seen.add(trimmed);
    labels.push(trimmed);
  });

  return labels;
};
